// THIS FILE IS ONLY FOR IDE ENTRY CHECKING NOT FOR REAL USAGE

import MarqueeTips from './src/components/MarqueeTips.vue'

export default MarqueeTips



//////////////////
// WEBPACK FOOTER
// ./~/vue-marquee-tips/index.js
// module id = 242
// module chunks = 0